/**
 * Maximum open-grid code length accepted from clients. Real DMS grid codes are short slugs
 * ("business-case", "vehicle-opensearch"); anything longer is a malformed or hostile snapshot.
 */
export const ASSISTANT_ACTIVE_GRID_CODE_MAX_CHARACTERS = 128;
